'use client';
import React from 'react';

import PricingSectionDesktop from '@/blocks/PricingSection/Desktop/PricingSectionDesktop';
import PricingSectionMobile from '@/blocks/PricingSection/Mobile/PricingSectionMobile';
import { NormalizedPricingSectionProps } from '@/blocks/PricingSection/types';
import { getPricingSectionContentProps } from '@/blocks/PricingSection/utils';
import Section from '@/components/atoms/Section/Section';
import { Toggle } from '@/components/atoms/Toggle';
import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';

const PricingSectionContent = (props: NormalizedPricingSectionProps) => {
  const [selectedTab, setSelectedTab] = React.useState<string | null>(
    props.tabs[0] || null
  );

  const shouldDisplayTabs = props.tabs.length > 1;

  const transformedProps = React.useMemo(
    () =>
      getPricingSectionContentProps(
        props.columns,
        props.headerColumns,
        props.contactSalesColumns,
        selectedTab
      ),
    [props.columns, props.headerColumns, props.contactSalesColumns, selectedTab]
  );

  return (
    <div className='w-full'>
      <div className='headerLg:mt-4 headerLg:mb-14 mb-9'>
        <div className='flex justify-center'>
          {shouldDisplayTabs && (
            <Toggle
              options={props.tabs}
              onValueChange={(val) => setSelectedTab(props.tabs[val])}
              classNames={{
                container: 'w-full headerLg:w-auto md:w-full',
              }}
            />
          )}
        </div>
      </div>

      <Section
        data-tracker-section={SECTION_NAMES.PRICING_SECTION}
        className='hidden headerLg:flex flex-1'
      >
        <PricingSectionDesktop {...transformedProps} />
      </Section>
      <Section
        data-tracker-section={SECTION_NAMES.PRICING_SECTION}
        className='flex headerLg:hidden flex-1'
      >
        <PricingSectionMobile {...transformedProps} />
      </Section>
    </div>
  );
};

export default PricingSectionContent;
